import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { CallOffsList } from '~/modules/callOff';

import { getSchemaDefaults } from '@vestigas/utils';
import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams, zodCallOffsRouteParamsSchema } from './-routeParams';

const title = i18n.t(($) => $.list.pageTitle, { ns: 'callOff' });

export const Route = createFileRoute('/(main)/demand/call-offs/')({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/call-offs',
    ...routeParams,
  }),
  component: CallOffsList,
  head: () => getRouteHead(title, 'Rufe Material aus Verträgen ab'),
  search: {
    middlewares: [
      stripSearchParams(getSchemaDefaults(zodCallOffsRouteParamsSchema)),
    ],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodCallOffsRouteParamsSchema,
});

export const DEMAND_CALLOFFS = buildRouteExport({
  Route,
  ...routeParams,
});
